const Bezeichnung = (props) => {
    const E = () => {
        switch (props.id) {
            case '1000053109': //45x45 VA PROFIL
                return 2000000;
            case '1000062111':
                return 2100000; //C-Schiene Stahl
            default:
                return 700000;
        }
    };

    return (
        <>
            <div className='col-2 posi-col-2-Beze'>
                <div className='Bezeichnung-container'>
                    <img
                        alt='Profilquerschnitt'
                        src={
                            props.array === ''
                                ? null
                                : props.array.data.base_image
                        }
                    ></img>
                    <div className='Arti-Beze-container'>
                        <p>
                            {props.array === ''
                                ? 'Profil'
                                : props.array.data.description}
                        </p>
                        <p>
                            Artikel-Nr.{' '}
                            {props.array === ''
                                ? 'Profil'
                                : props.array.data.name}
                        </p>

                        {props.language === 'DE' ? (
                            <p>E-Modul: {E() / 10000} N/m²</p>
                        ) : (
                            <p>E-modul: {E() / 10000} N/m²</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Bezeichnung;
